import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxMinus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.1 0C0.940201 0 0 0.940203 0 2.1V21.9C0 23.0598 0.940203 24 2.1 24H21.9C23.0598 24 24 23.0598 24 21.9V2.1C24 0.940201 23.0598 0 21.9 0H2.1ZM1.8 2.1C1.8 1.93431 1.93432 1.8 2.1 1.8H21.9C22.0657 1.8 22.2 1.93432 22.2 2.1V21.9C22.2 22.0657 22.0657 22.2 21.9 22.2H2.1C1.93431 22.2 1.8 22.0657 1.8 21.9V2.1Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 12.0602C6 11.5631 6.40294 11.1602 6.9 11.1602H17.1C17.5971 11.1602 18 11.5631 18 12.0602C18 12.5572 17.5971 12.9602 17.1 12.9602H6.9C6.40294 12.9602 6 12.5572 6 12.0602Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgCheckboxMinus;
